<!--
  IpForm : Ipv4 Component

  @since 2017-11-10
  @author kdydesign.kim
-->

<template>
  <div class="inline-group bs bs-q-ip-input bs-q-ip-input-default bs-q-ip-input-ipV4 bs-q-ip-input-mask">
    <div v-for="(seg, index) in ipv4Segments"
         :key="index"
         class="bs"
    >
      <!--TAMS HA Force 제거-->
      <q-input type="text"
               align="center"
               style="width:50px;"
               :auth-force="authForce"
               class="bs bs-q-input bs-q-input-default"
               v-validate="getIPAddressRules"
               :ref="`ipv4_${index}`"
               :key="`${name}_ipv4seg_${index}`"
               :name="`${name}_ipv4seg_${index}`"
               :value="seg"
               :error="dataVvScope === '' ? errors.has(`${name}_ipv4seg_${index}`) : errors.has(`${dataVvScope}.${name}_ipv4seg_${index}`)"
               :disable="disable"
               :readonly="readonly"
               :maxlength="3"
               :data-vv-scope="dataVvScope || null"
               @input="onInputAddress($event, index)"
               @keydown="onKeydownAddress($event, index)"
      />
      <span v-if="index < 3" class="contents-option-con">.</span>
    </div>
    <!--TAMS HA Force 제거-->
    <q-btn :title="`IP ${$t('cmn.copy')}`"
           :auth-force="authForce"
           v-clipboard:copy="ipv4Segments.join('.')"
           color="primary"
           outline="outline"
           class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line">
      <q-icon class="bs-q-btn-icon bs-q-btn-icon-ip-copy-sm"/>
    </q-btn>

    <!-- Ping 전송 버튼 -->
    <!--TAMS HA Force 제거-->
    <ping-button v-if="ping"
                 key="ipV4PingBtn"
                 :readonly="readonly"
                 :auth-force="authForce"
                 title="IPv4 Ping"
                 :value="ipv4Segments.join('.')"
    />

    <!--mask 영역-->
    <div v-show="useNetmask"
         class="bs">
      <span class="contents-option-con">/</span>
      <!--TAMS HA Force 제거-->
      <q-input ref="maskField"
               type="text"
               :auth-force="authForce"
               align="center"
               style="width:42px;"
               class="bs bs-q-input bs-q-input-default marL0"
               maxlength="2"
               v-model.number="maskValue"
               v-validate="getNetmaskRules"
               :key="`${name}_netmask`"
               :name="`${name}_netmask`"
               :error="dataVvScope === '' ? errors.has(`${name}_netmask`) : errors.has(`${dataVvScope}.${name}_netmask`)"
               :disable="disable"
               :readonly="readonly"
               :data-vv-scope="dataVvScope || null"
               @input="onInputNetmask"
               @blur="onBlurNetmask"
               @focus="$refs.maskField.select()"
               @keyup="onKeyupNetmask"
               @keydown="onKeydownNetmask"
      >
        <q-tooltip v-if="useNetmask"
          self="bottom middle"
          anchor="top middle"
          class="bs bs-q-tooltip bs-q-tooltip-default"
          :offset="[10, 10]"
        >
          <em>{{ $t('cmn.valueRange', {'min': maskMinValue, 'max': maskMaxValue}) }}</em>
        </q-tooltip>
      </q-input>
    </div>
  </div>
</template>

<script>
  import PingButton from '../PingButton'

  const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/

  export default {
    name: 'Ipv4Address',
    components: {
      PingButton
    },
    props: {
      ip: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        required: true
      },
      mask: {
        type: [Number, String],
        default: void 0
      },
      ping: {
        type: Boolean,
        default: false
      },
      error: {
        type: Boolean,
        default: false
      },
      disable: {
        type: Boolean,
        default: false
      },
      isValid: {
        type: Boolean,
        default: true
      },
      required: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      validator: {
        type: Object,
        default: void 0,
        validator: function (value) {
          return value
        }
      },
      dataVvScope: {
        type: String,
        default: ''
      },
      maskMaxValue: {
        type: Number,
        default: 32
      },
      maskMinValue: {
        type: Number,
        default: 0
      },
      authForce: {
        type: Boolean,
        default: false
      },
      // TAMS 미사용
      haForce: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        self: this,
        maskValue: void 0,
        ipv4Segments: ['', '', '', '']
      }
    },
    computed: {
      useNetmask () {
        return this.mask !== void 0
      },
      getNetmaskRules () {
        return this.disable ? '' : this.required && this.useNetmask ? `required|isValidNetmask:${this.maskMinValue},${this.maskMaxValue}`
          : !this.required && this.useNetmask && this.checkInputAddress ? `required|isValidNetmask:${this.maskMinValue},${this.maskMaxValue}`
            : !this.required && this.useNetmask && this.maskValue ? `isValidNetmask:${this.maskMinValue},${this.maskMaxValue}` : ''
      },
      getIPAddressRules () {
        return this.disable ? '' : this.required ? 'required' : this.isValid && this.checkInputAddress ? 'required' : this.isValid && this.maskValue ? 'required' : ''
      },
      checkInputAddress () {
        for (const seg of this.ipv4Segments) {
          if (seg !== '') {
            return true
          }
        }

        return false
      }
    },
    created () {
      // 전달된 Validator가 없을경우 자기 자신의 Validator 객체를 전달한다.
      this.$validator = this.validator || this.$validator
    },
    mounted () {
      // Watch에서 인식하지 못할 경우를 대비한 초기값 설정
      let ip = this.ip
      this.ipv4Segments = ip ? ip.split('.') : ['', '', '', '']

      // Watch에서 인식하지 못할 경우를 대비한 Mask 초기값 설정
      if (this.useNetmask) {
        this.maskValue = (this.mask === 0 || this.mask) ? this.mask : void 0
      }

      // 복사기능 적용
      const inputCons = this.$el.getElementsByTagName('input')

      _.each(inputCons, (thisCon, index) => {
        thisCon.addEventListener('paste', (event) => {
          this.onPaste(event, index)
        })
      })
    },
    beforeDestroy () {
      // IPv4 컴포넌트 초기화
      this.clear()

      // 셀프 객체 초기화
      this.self = null
    },
    methods: {
      // IPv4 주소입력 시작
      /*
        이름: onInputAddress
        설명: IPv4 주소를 모델에 입력한다.
      */
      onInputAddress (value, index) {
        let ipAddress = ''
        const segment = Number(value)

        // 값이 없으면 해당 인덱스 빈문자열 처리
        if (isNaN(segment) || value === '') {
          this.ipv4Segments[index] = ''
          this.$refs[`ipv4_${index}`][0].$data.model = ''
        } else if (segment > 255 || segment < 0) {
          this.ipv4Segments[index] = '255'
          this.$refs[`ipv4_${index}`][0].$data.model = '255'
        } else if (!isNaN(segment)) {
          this.ipv4Segments[index] = _.toString(segment)
        }

        if (!isNaN(segment) && value.length === 3 && index < 3) {
          this.$el.getElementsByTagName('input')[index + 1].focus()
        }

        // 모두 비어있는 경우 확인
        let checkNonEmpty = false
        for (const seg of this.ipv4Segments) {
          if (seg !== '') {
            checkNonEmpty = true
            break
          }
        }

        // IPv4 유효성 검사 수행 후 이상 없을경우 모델에 입력
        ipAddress = this.ipv4Segments.join('.')

        // 양방향 바인딩
        this.$emit('update:ip', checkNonEmpty ? ipAddress : null)

        // 유효성 검사 딜레이 지정 후 수행
        const self = this.self
        setTimeout(function () {
          self.$validator.validateAll()
        }, 50)
      },
      /*
        이름: onKeydownAddress
        설명: 특수문자 입력을 차단한다.
      */
      onKeydownAddress (event, index) {
        // 이벤트 키코드 가져오기
        const keyCode = event.keyCode

        // 알파벳 범위 (a ~ z)
        const isAlpha = keyCode > 64 && keyCode < 91

        // 특수기호 및 공백
        const isSpecWord = (keyCode > 105 && keyCode < 112) || (keyCode > 185 && keyCode < 193) || (keyCode > 218 && keyCode < 223) || keyCode === 32

        if (!event.ctrlKey) {
          // '.' 입력 시 다음 칸 이동
          if (keyCode === 110 || keyCode === 190) {
            if (index !== undefined && index < 3) {
              this.$el.getElementsByTagName('input')[index + 1].focus()
            }

            // 크롬 / 파이어폭스 / 사파리 이벤트 차단
            event.returnValue = false

            // IE 이벤트 차단
            event.preventDefault()
          } else if (isAlpha || isSpecWord) {
            // 알파벳, 특수기호 및 공백 입력 불가

            // 크롬 / 파이어폭스 / 사파리 이벤트 차단
            event.returnValue = false

            // IE 이벤트 차단
            event.preventDefault()
          }
        }
      },
      // Netmask 관련 이벤트 시작
      /*
        이름: onBlurNetmask
        설명: 한글, 알파벳, 특수문자를 빈문자열로 치환하고 모델에 전달한다.
      */
      onBlurNetmask (event) {
        const self = this.self
        setTimeout(() => {
          const beforeValue = event.target.value
          const blockHangul = beforeValue.replace(/[^0-9]/gi, '')
          self.netmaskValue = blockHangul
        }, 1)
      },
      /*
        이름: onInputNetmask
        설명: Netmask input 이벤트 핸들러. 내부 모델에 데이터를 추가한다.
      */
      onInputNetmask (value) {
        // Netmask 값을 숫자형으로 변환
        // -. 빈값일 경우 숫자형으로 변환 안하게 막음
        //    : 빈값을 숫자형으로 변환시 0으로 변환이 되어 mask 범위가 0을 포함하지 않을 경우
        //      UI에서는 값이 없어 보이나 내부적으로는 0 값을 가지고 있어 유효하지 않는 것으로 판단 됨.
        const convertNetmask = (_.size(value) > 0) ? Number(value.replace(/[^0-9]/gi, '')) : value

        // 넷마스크 타입이 number 일 경우
        this.netmaskValue = (convertNetmask === 0 || convertNetmask) ? convertNetmask : ''

        this.$refs.maskField.$data.model = this.netmaskValue

        // 양방향 바인딩
        this.$emit('update:mask', this.netmaskValue)

        // 유효성 검사 딜레이 지정 후 수행
        const self = this.self
        setTimeout(function () {
          self.$validator.validateAll()
        }, 50)
      },
      /*
        이름: onKeyupNetmask
        설명: 한글, 알파벳, 특수문자를 빈문자열로 치환하고 모델에 전달한다.
      */
      onKeyupNetmask (event) {
        if (!(event.keyCode >= 37 && event.keyCode <= 40)) {
          const beforeValue = event.target.value
          const blockHangul = beforeValue.replace(/[^0-9]/gi, '')
          this.maskValue = blockHangul
        }
      },
      /*
        이름: onKeydownNetmask
        설명: IPv4 넷마스크 컴포넌트에서 특수문자가 입력되지 않도록 분기처리한다.
      */
      onKeydownNetmask (event) {
        // 키코드 얻어오기
        const keyCode = event.keyCode

        // 알파벳 범위 (a ~ z)
        const isAlpha = keyCode > 64 && keyCode < 91

        // 특수기호 및 공백
        const isSpecWord = (keyCode > 105 && keyCode < 112) || (keyCode > 185 && keyCode < 193) || (keyCode > 218 && keyCode < 223) || keyCode === 32

        if (isAlpha || isSpecWord) {
          event.returnValue = false
          event.preventDefault()
        }
      },
      // 부가 기능
      /*
        이름: onPaste
        설명: 설정된 IP를 복사한다.
      */
      onPaste (event, index) {
        let ip = ''
        const pasteText = event.clipboardData.getData('text/plain')

        if (ipRegex.test(pasteText)) {
          let ipv4Segments = pasteText.split('.')

          ipv4Segments.forEach((segment, i) => {
            let value = Number(segment)

            if (index + i < 4 && !isNaN(value) && value >= 0 && value <= 255) {
              this.ipv4Segments.splice(index + i, 1, value)
            }

            if (value > 255) {
              this.ipv4Segments.splice(index + i, 1, '255')
            }
          })

          ip = this.ipv4Segments.join('.')

          this.$emit('update:ip', ip)
        }

        event.returnValue = false
      },
      /*
        이름: clear
        설명: IPv4 컴포넌트 상태를 초기화 한다.
      */
      async clear () {
        // 유효성 검사 초기화
        await this.$validator.reset()

        // 내부 모델 초기화
        this.maskValue = void 0
        this.ipv4Segments = ['', '', '', '']

        // IP Address에 관련된 에러백 제거
        for (let i = 0; i < 4; i++) {
          this.errors.remove(`${this.name}_${i}`)
        }

        // Netmask에 관련된 에러백 제거
        this.errors.remove(`${this.name}_netmask`)
      },
      /*
        이름: validate
        설명: IPv4 컴포넌트의 유효성 검사를 수행한다.
      */
      async validate () {
        const resValidate = await this.$validator.validateAll()

        return resValidate
      }
    },
    watch: {
      ip (ipAddress) {
        this.ipv4Segments = ipAddress ? ipAddress.split('.') : ['', '', '', '']
      },
      mask (netmask) {
        this.maskValue = (netmask === 0 || netmask) ? netmask : void 0
      }
    }
  }
</script>
